export default __webpack_public_path__ + "static/media/resume.8508d4c7.pdf";